import { FunctionComponent } from "react";
import styles from "./styles.module.css";

interface dadoProps {
  chave: string;
  valor: string;
  estilo?: string;
}

const LinhaDado: FunctionComponent<dadoProps> = ({ chave, valor, estilo }) => {
  return (
    <>
      <span className={styles.linhaDado}>
        <strong>{chave}:</strong> <span className={estilo}>{valor}</span>
      </span>
    </>
  );
};

export default LinhaDado;
